import { API_BASE } from '../config/app';

function createRequestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function getErrorMessage(data, fallback) {
  if (typeof data?.message === 'string' && data.message.trim()) return data.message;
  if (typeof data?.error === 'string' && data.error.trim()) return data.error;
  return fallback;
}

const requestCache = new Map();
const pendingRequests = new Map();

export async function apiRequest(path, options = {}) {
  const { headers, body, ...rest } = options;
  const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...rest,
    ...(body !== undefined ? { body } : {}),
    headers: {
      Accept: 'application/json',
      ...(!isFormData ? { 'Content-Type': 'application/json' } : {}),
      'X-Request-ID': createRequestId(),
      ...headers,
    },
  });

  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await response.json().catch(() => ({}))
    : await response.text();

  if (!response.ok) {
    throw new Error(getErrorMessage(data, 'Request failed. Please try again.'));
  }

  return data;
}

export async function cachedApiRequest(path, options = {}) {
  const { cacheTtlMs = 5 * 60 * 1000, cacheKey = path, ...requestOptions } = options;
  const method = String(requestOptions.method || 'GET').toUpperCase();

  if (method !== 'GET' || cacheTtlMs <= 0) {
    return apiRequest(path, requestOptions);
  }

  const cached = requestCache.get(cacheKey);
  if (cached && Date.now() - cached.createdAt < cacheTtlMs) {
    return cached.data;
  }

  if (pendingRequests.has(cacheKey)) {
    return pendingRequests.get(cacheKey);
  }

  const request = apiRequest(path, requestOptions)
    .then((data) => {
      requestCache.set(cacheKey, { createdAt: Date.now(), data });
      return data;
    })
    .finally(() => {
      pendingRequests.delete(cacheKey);
    });

  pendingRequests.set(cacheKey, request);
  return request;
}

export function getPaginatedRows(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.templates?.data)) return payload.templates.data;
  return [];
}
